import { ReactElement } from 'react';
import { ProductFeature } from '@localstack/types';
import { useRoutes } from '@localstack/services';

import { ContainedCustomerLayout } from '~/layouts';
import { useAuthProvider } from '~/hooks/useAuthProvider';
import { AppRoute } from '~/config';

import { SSOSettings } from './components/SingleSignOnSettings/SSOSettings';

export const SingleSignOnSettings = (): ReactElement => {
  const { hasFeature } = useAuthProvider();
  const { goto } = useRoutes();

  if (!hasFeature(ProductFeature.FEATURE_SSO)) {
    goto(AppRoute.NOT_FOUND);
  }

  return (
    <ContainedCustomerLayout title="Single Sign-on Settings">
      <SSOSettings />
    </ContainedCustomerLayout>
  );
};
